<template>
  <div
    id="assess-card-wrapper"
    class="tw-flex tw-gap-[20px] tw-max-w-[1361px] tw-flex-wrap"
  >
    <div id="assess-manager-completion-card" class="tw-flex-1">
      <CompletionCard
        v-if="isMounted"
        :detail="detail"
        :class="'tw-flex-1 tw-min-w-[290px]'"
      />
      <CompletionCardSkeleton v-else :class="'tw-flex-1 tw-max-w-none'" />
    </div>
    <div id="assess-manager-details-card" class="tw-flex-1">
      <DetailsCard v-if="isMounted" :class="'tw-flex-1 tw-max-w-none'" />
      <DetailsCardSkeleton v-else :class="'tw-flex-1 tw-max-w-none'" />
    </div>
    <div
      id="assess-manager-contributors-card"
      class="tw-flex-1 tw-max-w-[calc(50%-10px)]"
    >
      <ContributorsCard
        v-if="isMounted"
        :class="'tw-flex-1 tw-max-w-none'"
        :checklist-id="props.contributorsCard"
      />
      <ContributorsCardSkeleton v-else :class="'tw-flex-1 tw-max-w-none'" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import CompletionCard from "./completionCard.vue";
import ContributorsCard from "./contributorsCard.vue";
import DetailsCard from "./detailsCard.vue";
import CompletionCardSkeleton from "./../skeleton/completionCardSkeleton.vue";
import DetailsCardSkeleton from "./../skeleton/detailsCardSkeleton.vue";
import ContributorsCardSkeleton from "./../skeleton/contributorsCardSkeleton.vue";

import { computed, onMounted, ref, watch } from "vue";
import store from "@/store";
import { useRoute } from "vue-router";

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  contributorsCard: {
    type: Number,
    default: 0,
  },
  detail: {
    type: Object,
    default: () => ({}),
  },
});

const route = useRoute();
const isMounted = ref(false);
const queryValue = computed(() => Number(route.query.checklistId));

watch(
  () => queryValue.value,
  (newVal) => {
    if (newVal) {
      isMounted.value = false;
      setTimeout(() => {
        isMounted.value = true;
      }, 1000);
    }
  },
);

onMounted(() => {
  setTimeout(() => {
    isMounted.value = true;
  }, 1000);
});
</script>

<style scoped lang="scss">
#assess-manager-contributors-card {
  @media (max-width: 608px) {
    max-width: 100%;
  }
}
</style>
